import { Product } from './Product';

export class Present extends Product {
  constructor(params: Present = {} as Present) {
    super(params);
  }
}
